var map = {
	"./dhl.png": "./src/assets/images/serverSupply/dhl.png",
	"./dpd.png": "./src/assets/images/serverSupply/dpd.png",
	"./fedex.png": "./src/assets/images/serverSupply/fedex.png",
	"./feepower.png": "./src/assets/images/serverSupply/feepower.png",
	"./ups.png": "./src/assets/images/serverSupply/ups.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/serverSupply sync recursive ^\\.\\/.*\\.png$";